import React from 'react'
import Chart from 'react-apexcharts'

const ChartStatus = ({ data }) => {
    // Extract labels and series from data
    const labels = data?.statusSummary?.map((item) => item.status) || []
    const series = data?.statusSummary?.map((item) => item.count) || []

    // Define colors for each status
    const colorMap = {
        Pending: '#faad14', // orange
        Pass: '#52c41a', // green
        Fail: '#db2114', // red
        Retest: '#1890ff', // blue
    }

    const options = {
        chart: {
            type: 'pie',
        },
        labels,
        colors: labels.map((label) => colorMap[label] || '#d9d9d9'),
        legend: {
            position: 'bottom',
        },
        stroke: {
            show: false, // 🔥 disables that white separator line
        },
        dataLabels: {
            enabled: true,
            formatter: function (val, opts) {
                const count = opts.w.config.series[opts.seriesIndex]
                return `${count} (${val.toFixed(0)}%)`
            },
        },
        plotOptions: {
            pie: {
                dataLabels: {
                    offset: -20, // ⬅️ negative = toward center
                    minAngleToShowLabel: 8, // hide labels for tiny slices (optional)
                },
            },
        },
        tooltip: {
            y: {
                formatter: (val) => `${val} items`,
            },
        },
    }

    return <Chart options={options} series={series} type="pie" height={300} />
}

export default ChartStatus
